import Typography from '@mui/material/Typography';

/**
 * Componente DataGridNoRowsOverlay
 *
 * Muestra un mensaje personalizado cuando no hay filas en el DataGrid.
 *
 * @component
 * @param {object} props - Props del componente.
 * @param {boolean} [props.searchByFilter] - Indica si la búsqueda fue por filtro.
 * @param {string} [props.messageNoRows] - Mensaje por defecto cuando no hay registros.
 * @param {string} [props.customMessageNoRows] - Mensaje personalizado cuando no hay registros.
 * @example
 * <DataGridNoRowsOverlay messageNoRows="No hay datos" />
 */

type Props = {
  searchByFilter?: boolean;
  messageNoRows?: string;
  customMessageNoRows?: string;
};

function DataGridNoRowsOverlay({
  searchByFilter,
  messageNoRows = 'registros',
  customMessageNoRows = undefined
}: Props = {}) {
  return (
    <Typography
      align="center"
      component="div"
      height="100%"
      sx={{
        fontWeight: 'normal',
        color: '#063468',
        fontSize: '14px',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center'
      }}
      variant="h4"
      gutterBottom
    >
      {searchByFilter
        ? `No se encontraron resultados.`
        : customMessageNoRows || `${messageNoRows}`}
    </Typography>
  );
}

export default DataGridNoRowsOverlay;
